console.log('🌟 process.env.CDN_ENV', process.env.CDN_ENV)
console.log('🌟 process.env.RUNTIME', process.env.RUNTIME)
if (!process.env.CDN_ENV || !process.env.RUNTIME) {
  console.error('找不到 process.env.CDN_ENV 或 process.env.RUNTIME, 请检查编译配置！')
}

const BASE_URL_MAP = {
  cdn: {
    local: '/wuhan-test/dist/',
    development: '/wuhan-test/dist/',
    pre: '/wuhan-pre/dist/',
    production: '/wuhan/dist/'
  },
  wx: {
    local: '/m/2020012115175001',
    development: '/m/2020012115175001',
    production: '/m/2020012115185202'
  }
}

const BASE_URL = BASE_URL_MAP[process.env.RUNTIME][process.env.CDN_ENV]

const ERROR_CODE = {
  EC_SUCCESS: 0,
  EC_SYS_ERROR: 701501,
  EC_ACTIVITE_END: 701511, // 活动结束
  EC_SENSITIVE: 701512 // 不通过敏感词检验
}

const CDN_MAP = {
  cdn: {
    development: 'wuhan-test/dist',
    pre: 'wuhan-pre/dist',
    production: 'wuhan/dist'
  },
  wx: {
    development: 'wuhan-lung-test/dist',
    production: 'wuhan-lung-prod/dist'
  }
}

const CDN_PATH = process.env.CDN_PATH || CDN_MAP[process.env.RUNTIME][process.env.CDN_ENV]

console.log('🌟 BASE_URL', BASE_URL)
console.log('🌟 CDN_PATH', CDN_PATH)

const FEIYANMAP_REQUEST_BASEURL_MAP = {
  local: 'https://mitest.wecity.qq.com',
  development: 'https://mitest.wecity.qq.com',
  pre: 'https://mitest.wecity.qq.com',
  production: 'https://card.wecity.qq.com'
}
const MAP_REQUEST_BASEURL = FEIYANMAP_REQUEST_BASEURL_MAP[process.env.CDN_ENV]

const MISC_URL_MAP = {
  local: 'https://misc.wecity.qq.com',
  development: 'https://misc.wecity.qq.com',
  pre: 'https://misc.wecity.qq.com',
  production: 'https://misc.wecity.qq.com'
}
const MISC_URL = MISC_URL_MAP[process.env.CDN_ENV]

const COOKIE_KEY_MAP = { // 用以检测的 Cookie Key
  local: 'p_thlogin_stat',
  development: 'p_thlogin_stat',
  pre: 'p_thlogin_stat',
  production: 'thlogin_stat'
}
const COOKIE_KEY_PRXFIX = COOKIE_KEY_MAP[process.env.CDN_ENV]
const COOKIE_KEY = COOKIE_KEY_PRXFIX + '_0_450_a33_sid'

const AUTH_URL_MAP = { // 需要跳转进行授权的地址, 正式环境跳转 https://card.wecity.qq.com/wxlogin
  local: 'https://mitest.wecity.qq.com/wxlogin',
  development: 'https://mitest.wecity.qq.com/wxlogin',
  pre: 'https://mitest.wecity.qq.com/wxlogin',
  production: 'https://card.wecity.qq.com/wxlogin'
}
const AUTH_URL = AUTH_URL_MAP[process.env.CDN_ENV]

module.exports = {
  BASE_URL,
  ERROR_CODE,
  CDN_PATH,
  MAP_REQUEST_BASEURL,
  MISC_URL,
  COOKIE_KEY,
  COOKIE_KEY_PRXFIX,
  AUTH_URL
}
